import DeclineOrderModalForm from './DeclineOrderModalForm';

export default DeclineOrderModalForm;
